parseEnumTypeExtension